import TagManager from 'react-gtm-module';

// Push events to the GTM data layer, mirroring the existing Klaviyo/Pinterest
// checkout events. Payloads carry product/checkout data only — never PII.
// Every push is guarded so a blocked or missing GTM never breaks checkout.
const push = (event: string, data?: Record<string, unknown>) => {
  try {
    TagManager.dataLayer({ dataLayer: { event, ...data } });
  } catch {
    // GTM unavailable (e.g. blocked by an ad blocker) — swallow silently.
  }
};

export const GtmTag = {
  addToCart: (data: { product_id: string; product_name: string; value: number; quantity: number }) => {
    push('add-to-cart', data);
  },

  beginCheckout: () => {
    push('begin-checkout');
  },
};
